import React, { useEffect, useState } from "react";
import Passchang from "../../images/impulse/passchang.svg";
import { CHANGEPASSWORD, APIGET } from "../../services/APIServices";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { MdOutlineVisibilityOff, MdOutlineVisibility } from "react-icons/md";
import { TextField, Button } from '@mui/material';
// import { TextField, Select, MenuItem, InputLabel, FormControl, Button } from '@mui/material';
import "../../css/Login.css";
import ThemeControls from "../../Component/AllThemesControl";
import Autocomplete from "@mui/material/Autocomplete";

function ResetPassword() {
  const [loginMsg, setLoginMsg] = useState("");
  const [succesMsg, setSuccesMsg] = useState("");
  const [data, setData] = useState({});
  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(false);
  const [showPassword, setshowPassword] = useState(true);
  const [restToken, setRestToken] = React.useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  
  useEffect(() => {
    async function settingData() {
      return await APIGET('user' + `/all`).then(data => {
        if (data?.data) {
          setUsers(data.data); 
        }
      }).catch(() => {
        setLoginMsg("Failed to fetch users.");
        setOpen(true);
      });
    }
    settingData();
    const token = localStorage.getItem("token");
    setRestToken(token);
  }, []);

  const handleClose = () => setOpen(false);

  function handleClickShowPassword() {
    setshowPassword(current => !current);
  }

  function handlePasswordChange(e) {
    const value = e.target.value;
    setPassword(value);
    setData(prevState => ({ ...prevState, passcode: value, passcodeverify: value }));
  }

  // function handleUserSelect(e) {
  //   const userid = e.target.value;
  //   setSelectedUser(userid);
  //   setData(prevState => ({ ...prevState, userid }));
  // }

  async function funcResetPassword(data) {
    const ApiContext = `user/updateaspassword`;
    const resData = await CHANGEPASSWORD(data, ApiContext, restToken).catch(() => {
      setLoginMsg("Failed to Change the password. Please try again later.");
      setOpen(true);
    });

    if (resData?.statusCode === "SUCCESS") {
      setPassword("");
      setSelectedUser(null);
      setSuccesMsg("Password has been changed successfully.");
    }
  }

  return (
    <>
      <Snackbar className={classes.errorpopup}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        onClose={handleClose}
        autoHideDuration={4000}
      >
        <Alert severity="error">{loginMsg}</Alert>
      </Snackbar>

      <div className={classes.main}>
        <div className="df jcse ais">
          <div className="imgBox">
            <img width='430px' src={Passchang} alt="" />
          </div>
          <div style={{ width: '550px' }}>
            <div className="login-tabs">
              <div className="buttons">
                <button className="tab-1 active">Change Password</button>
              </div>
            </div>
            <div className="wrap jcc df">
              <div className="form_wrapper content-1 active">
                <form method="post" onSubmit={(e) => { e.preventDefault(); funcResetPassword(data); }}>
                  {succesMsg ? <p className="termsg">{succesMsg}</p> : <p className="terms">Enter your new password below, we're just being extra safe</p>}
                  
                  {/* <div className="login_input">
                    <FormControl fullWidth>
                      <InputLabel>User Name</InputLabel>
                      <Select
                        value={selectedUser}
                        onChange={handleUserSelect}
                        label="User Name"
                        fullWidth
                      >
                        <MenuItem value="">
                          <em>Select User</em>
                        </MenuItem>
                        {users.map(user => (
                          <MenuItem key={user.userid} value={user.userid}>{user.firstname + ' ' + user.lastname}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div> */}

                  <Autocomplete
                      id="userid"
                      options={users}
                      getOptionLabel={(user) => `${user.firstname} ${user.lastname}`}
                      value={selectedUser}
                      onChange={(event, newValue) => {
                        setSelectedUser(newValue);
                        setData((prevState) => ({
                          ...prevState,
                          userid: newValue ? newValue.userid : "",
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select User"
                          variant="outlined"
                          required
                        />
                      )}
                    />

                  {/* <div className="login_input">
                    <TextField
                      type={showPassword ? 'text' : 'password'}
                      label="New Password"
                      value={password}
                      onChange={handlePasswordChange}
                      fullWidth
                    />
                    <div className="pass" onClick={handleClickShowPassword}>
                      {showPassword ? <MdOutlineVisibility /> : <MdOutlineVisibilityOff />}
                    </div>
                  </div> */}
                  <TextField
                    fullWidth
                    margin="normal"
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    label="New Password"
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Password"
                    required
                    InputProps={{
                      endAdornment: (
                        <div style={{width: '25px'}} onClick={handleClickShowPassword}>
                          {showPassword ? <MdOutlineVisibility /> : <MdOutlineVisibilityOff />}
                        </div>
                      )
                    }}
                  />
                  {/* {Boolean(errorMsg) && <p className="errorMsg">{errorMsg}</p>} */}

                  <div className="btn_wrap" style={{marginTop: '20px'}}>
                    <Button style={{width: '100%', height: '56px'}} variant="contained" color="primary" type="submit">Change Password</Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
